import { QuoteFeeType } from "@trnsact/trnsact-shared-types";
import { UpdateInvoiceVariables } from "modules/invoice/api/types";
import { CreateOrUpdateQuoteVariables } from "../api/types";

export function collectInvoiceDTOFromQuote({
  equipment,
  fees,
}: Omit<CreateOrUpdateQuoteVariables["input"], "vendorOpportunityId">): UpdateInvoiceVariables["fieldsObj"] {
  const equipmentCost = equipment.reduce((calcCost, { cost }) => (calcCost += cost), 0);

  const salesTaxOnInvoice = fees.reduce((cost, { type, amount }) => {
    if (type === QuoteFeeType.StateTax) return (cost += amount);
    return cost;
  }, 0);

  const freightLaborInstallation = fees.reduce((cost, { type, amount, description }) => {
    if (type === QuoteFeeType.Other && description === "Other Charges (Installation, shipping etc.)") {
      return (cost += amount);
    }

    return cost;
  }, 0);

  return {
    equipmentCost,
    salesTaxOnInvoice,
    freightLaborInstallation,
  };
}
